import styled from "@emotion/styled";
import {ReactComponent as svg} from "../../../../images/iconMin.svg";

export const MinSvg = styled(svg)`
    padding-top: 4px;
    width: 28px;
    fill: #F79C41;
`;